import { defineStore } from 'pinia';
import { pcCardAssetChargeInfo } from '@/api/wallet';

function createFallbackList(address = '') {
  return [
    {
      symbol: 'USDT',
      logo: '',
      chains: [
        {
          symbolType: 'BEP20',
          chargeAddress: address || '0x0000000000000000000000000000000000000000'
        }
      ]
    }
  ];
}

export const useWalletTopupStore = defineStore('wallet-topup', {
  state: () => ({
    loading: false,
    list: [],
    selectedCoinIndex: 0
  }),
  getters: {
    selectedCoin(state) {
      return state.list[state.selectedCoinIndex] || state.list[0] || null;
    }
  },
  actions: {
    reset(address = '') {
      this.loading = false;
      this.list = createFallbackList(address);
      this.selectedCoinIndex = 0;
    },
    setSelectedCoinIndex(index) {
      const nextIndex = Number(index);
      if (Number.isNaN(nextIndex) || nextIndex < 0 || nextIndex >= this.list.length) {
        return;
      }
      this.selectedCoinIndex = nextIndex;
    },
    async fetchChargeInfo({ address, reset = false } = {}) {
      if (reset || !this.list.length) {
        this.reset(address || '');
      }

      this.loading = true;
      try {
        const result = await pcCardAssetChargeInfo({ address: address || null });
        const rows = Array.isArray(result?.list) ? result.list : [];
        if (rows.length) {
          this.list = rows;
          if (this.selectedCoinIndex >= rows.length) {
            this.selectedCoinIndex = 0;
          }
        }
        return this.list;
      } catch (error) {
        if (!this.list.length) {
          this.reset(address || '');
        }
        throw error;
      } finally {
        this.loading = false;
      }
    }
  }
});
